import React from 'react';
import { Button } from 'antd';
import { MessageQuestionFilledIcon } from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { openAuthModal } from 'modules/auth';
import { globalConst } from 'modules/global';

interface IProps {
  name?: string;
  slug?: string;
  universityName?: string;
  universitySlug?: string;
  universityId?: string;
  language?: string | null;
  study?: string | null;
  contractPrice?: number;
  requirements?: string;
  passingScore?: number;
  id?: string;
  onOpenModal: (id?: string) => void;
  openApplicationModal: () => void;
  testAvailable?: boolean;
}

const DirectionCard: React.FC<IProps> = ({
  name,
  slug,
  universityName,
  universitySlug,
  language,
  study,
  contractPrice,
  requirements,
  passingScore,
  id,
  onOpenModal,
  openApplicationModal,
  testAvailable
}) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const isAuthorized = useAppSelector(({ user }) => user.phone);

  const onClick = () => {
    if (testAvailable) {
      return onOpenModal(id);
    }

    if (!isAuthorized) {
      return dispatch(openAuthModal());
    }

    return openApplicationModal();
  };

  return (
    <div className="group block w-full rounded-xl bg-white p-3">
      <div>
        <Link href={`${globalConst.pageNames.PRIVATE_UNIVERSITIES}/${universitySlug}/${slug}`}>
          <h3 className="font-bold group-hover:text-green-500 group-hover:underline">{name?.toUpperCase()}</h3>
        </Link>
        <p className="text-xs text-gray-700">{universityName}</p>
      </div>
      <div className="mt-3 grid grid-cols-2 items-center gap-2 rounded-xl bg-gray-50 px-3 py-2 sm:grid-cols-3 md:grid-cols-4">
        <div>
          <p className="mb-1 text-[0.6rem] text-gray-400">{t('TalimTili')}</p>
          <h4 className="text-xs font-medium">{language}</h4>
        </div>
        <div>
          <p className="mb-1 text-[0.6rem] text-gray-400">{t('TalimShakli')}</p>
          <h4 className="text-xs font-medium">{study}</h4>
        </div>
        <div>
          <p className="mb-1 text-[0.6rem] text-gray-400">{t('otish_bali')}</p>
          <h4 className="text-xs font-medium">
            {passingScore ? (
              <>
                {passingScore} {t('ball')}
              </>
            ) : (
              t('mavjud_emas')
            )}
          </h4>
        </div>
        <div>
          <p className="mb-1 text-[0.6rem] text-gray-400">{t('kontrakt_narxi')}</p>
          <div className="text-xs font-medium">
            {contractPrice ? (
              <>
                {Number(contractPrice)?.toLocaleString('ru')} <span className="text-xs">{t('somdan_boshlab')}</span>
              </>
            ) : (
              t('mavjud_emas')
            )}
          </div>
        </div>
      </div>
      <div className="mt-5 flex flex-col justify-between gap-2 sm:flex-row sm:items-center sm:space-y-0">
        <div className="sm:max-w-170 flex items-center gap-2 rounded-lg bg-yellow-50 px-2 py-1 text-xs">
          <div className="flex size-5 min-h-5 min-w-5 items-center justify-center rounded text-white bg-yellow-300">
            <MessageQuestionFilledIcon />
          </div>
          <div className="line-clamp-1">
            <b>{t('talablar')}: </b>
            {requirements || t('mavjud_emas')}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Link
            href={`${globalConst.pageNames.PRIVATE_UNIVERSITIES}/${universitySlug}/${slug}`}
            className="w-full rounded-lg border-transparent bg-indigo-100 px-2 py-1.5 text-center font-medium text-indigo-500 hover:bg-indigo-500 hover:text-white"
          >
            {t('profile.right_side.batafsil')}
          </Link>
          <Button
            onClick={onClick}
            className="!w-full !rounded-lg !border-transparent !bg-green-50 !py-4 !font-medium !text-green-500 hover:!bg-green-500 hover:!text-white sm:!w-40"
          >
            {testAvailable ? t('imtihon_topshirish') : t('ArizaQoldirish')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DirectionCard;
